module.exports = __webpack_public_path__ + "static/media/XXL_Carousel.5ee45acd.jpg";